import { apiClient } from '~/api/client'
import type { AuditLog } from '~/api/types'

// 감사 로그 읽기 API. 위험 작업(권한 변경·삭제 등)의 흔적을 읽기 전용으로 가시화한다.

export interface ListAuditParams {
    actor?: string
    action?: string
    limit?: number
    offset?: number
}

function toQuery(params: Record<string, string | number | undefined>): string {
    const search = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== '') {
            search.set(key, String(value))
        }
    }
    const qs = search.toString()
    return qs ? `?${qs}` : ''
}

/** GET /admin/api/audit — 감사 로그 목록(actor·action 필터, 페이지네이션). */
export function listAuditLogs(params: ListAuditParams = {}) {
    const query = toQuery({
        actor: params.actor,
        action: params.action,
        limit: params.limit,
        offset: params.offset,
    })
    return apiClient.get<AuditLog[]>(`/audit${query}`)
}

/** GET /admin/api/audit/export.csv — 현재 필터(actor·action·q)로 좁힌 감사 로그를
 *  CSV(UTF-8 BOM)로 내려받는다. 인증은 쿠키 기반이라 apiClient.downloadBlob에 위임한다. */
export function exportAuditLogs(
    params: Pick<ListAuditParams, 'actor' | 'action'> & { q?: string } = {}
) {
    const query = toQuery({
        actor: params.actor,
        action: params.action,
        q: params.q,
    })
    return apiClient.downloadBlob(`/audit/export.csv${query}`, 'audit-log.csv')
}
